import type { StyleConfigProps } from '../types';

export const BODY_VARIANTS = [
  'SmallRegular',
  'SmallBold',
  'MediumRegular',
  'MediumBold',
  'Default10',
  'Default12',
  'Default14',
  'Default16',
  'Bold10',
  'Bold12',
  'Bold14',
  'Bold16',
] as const;

export const BODY_CONFIG: StyleConfigProps<typeof BODY_VARIANTS> = {
  SmallRegular: {
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '22px',
  },
  SmallBold: {
    fontWeight: 700,
    fontSize: '14px',
    lineHeight: '22px',
  },
  MediumRegular: {
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '24px',
  },
  MediumBold: {
    fontWeight: 700,
    fontSize: '16px',
    lineHeight: '24px',
  },
  Default10: {
    fontWeight: 400,
    fontSize: '10px',
    lineHeight: '14px',
  },
  Default12: {
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: '18px',
  },
  Default14: {
    fontWeight: 400,
    fontSize: '14px',
    lineHeight: '21px',
  },
  Default16: {
    fontWeight: 400,
    fontSize: '16px',
    lineHeight: '24px',
  },
  Bold10: {
    fontWeight: 700,
    fontSize: '10px',
    lineHeight: '14px',
  },
  Bold12: {
    fontWeight: 700,
    fontSize: '12px',
    lineHeight: '18px',
  },
  Bold14: {
    fontWeight: 700,
    fontSize: '14px',
    lineHeight: '20px',
  },
  Bold16: {
    fontWeight: 700,
    fontSize: '16px',
    lineHeight: '24px',
  },
};
